var React = require('react');

function InPersonOutline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.3125 17.2358V14.2358","stroke":"#000000","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.38569 2.05581L2.45569 7.60581C1.67569 8.22581 1.17569 9.53581 1.34569 10.5158L2.67569 18.4758C2.91569 19.8958 4.27569 21.0458 5.71569 21.0458H16.9157C18.3457 21.0458 19.7157 19.8858 19.9557 18.4758L21.2857 10.5158C21.4457 9.53581 20.9457 8.22581 20.1757 7.60581L13.2457 2.06581C12.1757 1.20581 10.4457 1.20581 9.38569 2.05581Z","stroke":"#000000","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

InPersonOutline.defaultProps = {"width":"23","height":"22","viewBox":"0 0 23 22","fill":"none"};

module.exports = InPersonOutline;

InPersonOutline.default = InPersonOutline;
